import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetQuestions, useGetQuestionsList } from "../../hooks/groups/Questions";
import GroupQuestionsListItem from "./GroupQuestionsListItem";
import GroupQuestionsAllList from "./GroupQuestionsAllList";
import GroupQuestionsEditForm from "./GroupQuestionsEditForm";
import LoadingSpinner from "../global/LoadingSpinner";

function GroupQuestionsList({ id,  index, onSave, list = false }) {
    const { t } = useTranslation();

    // eslint-disable-next-line react-hooks/rules-of-hooks
    let { data, isLoading, isError } = list ? useGetQuestionsList(list) : useGetQuestions(id);
    const [questions, setQuestions] = useState([]);

    const [isNew, setIsNew] = useState(false)
    const [isAvailable, setIsAvailable] = useState(false);

    useEffect(() => {
        if(data) {
            setQuestions(data);
        }
    }, [data]);


    const onMove = (dragIndex, hoverIndex) => {
        const draggedItem = questions[dragIndex];
        const updatedQuestions = [...questions];
        updatedQuestions.splice(dragIndex, 1);
        updatedQuestions.splice(hoverIndex, 0, draggedItem);
        setQuestions(updatedQuestions); // Update the state
    };

    const onDrop = (item) => {
        onSave?.({
            type: 'onSave',
            data: questions.map(e => e.id),
            index: index,
        });
    }

    const toggleIdInArray = (array, id) => {
        const index = array.indexOf(id);
        if (index !== -1) array.splice(index, 1);
        else array.push(id);
        return array;
    }

    const handleAddToModules = (qId) => {
        const updateData = toggleIdInArray([...data.map(e => e.id)], qId);
        onSave?.({
            type: 'onSave',
            data: updateData,
            index: index,
        });

        setIsAvailable(false);
    }

    const onNew = (e) => {
        handleAddToModules(e);
    }

    if (isLoading) return <LoadingSpinner/>
    if (isError) return 'An error has occurred: ' + isError.message;

    return (<>
            <div className="questionsWrap">
                <div className="questionsWrapHeader">
                    <strong className="unbold">{t("admin.group.crit")}</strong>
                </div>
                <div className="emptyCheck">
                    {questions && questions.map((question, key) => {
                        return (<GroupQuestionsListItem key={`${id?id:"new"}__${key}`} index={key} moduleId={id} id={question.id} type={question.answer_type} text={question.text} onMove={onMove} onDrop={onDrop} onAddToModule={(e) => { handleAddToModules(e) }} />)
                    })}
                </div>
                <div className="">
                    {isNew && (<GroupQuestionsEditForm id={null} moduleId={id} onNew = {(e) => onNew(e) } onClose={() => setIsNew(false)}  />)}
                </div>
                <div>
                    {isAvailable && (<>
                    <GroupQuestionsAllList id={id} index="question_ids" moduleId={id} exclude={data.map(e => e.id)} onAddToModule={(e) => handleAddToModules(e) } />
                    <div className="blueBtnWrap blueBtnWrapClose">
                                        <button className="btn btn-save btn-close" title="Skrij onemogočene kriterije" 
                                            onClick={(e) => {setIsAvailable(false)}}>
                                            {t("admin.common.close")}
                                        </button>
                                    </div>
                    </>)}
        
                </div>
            </div>
        
        <div className='questionsWrap'>
            <div className="questionWrap questionWrapNew">
                <span></span>
                <p className="" onClick={() => { setIsAvailable(true) }}>{t("admin.group.aCrit")}</p>
                <p className="mx-2" onClick={() => { setIsNew(true); setIsAvailable(false) }} >{t("admin.group.anCrit")}</p>
            </div>
        </div>
    </>
    );
}

export default GroupQuestionsList;
